import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
// import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbButtonsModule, NgbDropdownModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {  HttpHeaders, HttpResponse,HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserComponent } from './admin-category/user/user.component';
import { MatTreeModule } from '@angular/material/tree';
import { CdkTreeModule } from '@angular/cdk/tree';
import { FileConfigModule } from './file-config/file-config.module';
import { Test1Component } from './file-config/test1/test1.component';
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule ,MatInputModule,MatNativeDateModule,MatProgressSpinnerModule} from '@angular/material';
import { MatTableModule } from '@angular/material';
import { MatSort } from '@angular/material';
import { MatTableDataSource } from '@angular/material';
import {Sort} from '@angular/material/sort';
import { MatSortModule } from '@angular/material';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './shared/loader.service';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { MatChipsModule } from "@angular/material/chips";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
//import { DndDirective } from './data-upload/dnd.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
 
// const config: SocketIoConfig = { url: 'http://localhost:5001', options: {} };
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    // NavSearchComponent,
    NavRightComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective,
    LoaderComponent,
    
   // DndDirective,
    
    
    
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    HttpClientModule,
    ReactiveFormsModule,
    CdkTreeModule,
    FileConfigModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
     MatButtonModule,
     MatTreeModule,
     MatInputModule,
     MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    //  MatTableDataSource,
    MatSortModule,
    MatTableModule,
    //  MatSort
    NgMultiSelectDropDownModule.forRoot(),
    FontAwesomeModule,
    // SocketIoModule.forRoot(config)
    //FormBuilder,
    //FormGroup

    
  
  ],

  entryComponents: [Test1Component],
  providers: [NavigationItem, LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
